exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_object-gops.js
// module id = 89
// module chunks = 2 3 4 5 6 7 8 9 10 11 12